import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from "@mui/material";
export default function CustomAlert({
  isError,
  message,
  showMessage,
  setShowMessage,
}) {
  return (
    <div>
      <Snackbar
        open={showMessage}
        autoHideDuration={2000}
        onClose={() => setShowMessage(false)}
        message="Done"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{ "& .MuiSnackbar-root": { bottom: "50px" } }}>
        <Alert severity={isError ? "error" : "success"} variant="filled">
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
}
